import React, { FC } from 'react';

// Styles
import './delete-account.scss';

type TDeleteAccountProps = {};

export const DeleteAccount: FC<TDeleteAccountProps> = (
  {}: TDeleteAccountProps
) => {

  return (
    <div className="delete-account">
      delete-account
    </div>
  );
}
